(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/finished-wager-summary.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/finished-wager-summary.js');

'use strict';

const {
  useAtomValue
} = jotai;
const {
  wagerHelper
} = svs.lyckoplatsen.shared_mybets_wager.utils;
const formatCurrency = svs.utils.format.Currency;
const {
  FormatTime
} = svs.utils.date;
const {
  DRAWS
} = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const {
  ProlongButton
} = svs.lyckoplatsen.components.shared_mybets_wager.react.components;
const FinishedWagerSummary = _ref => {
  var _currentWin$amount;
  let {
    wager
  } = _ref;
  const {
    selectedResultAtom
  } = svs.lyckoplatsen.components.shared_result.jotai.atoms;
  const result = useAtomValue(selectedResultAtom);
  const geoBoardData = wager.wager.bets[0].geoBoardData;
  const charity = wager.wagerCharity;
  const {
    totalDrawCount,
    addonTotalDrawCount,
    properties: {
      channel
    },
    regWagerTime,
    betAmount,
    completedDraws,
    wagerId,
    isSubscription
  } = wager;
  const {
    latitude,
    longitude
  } = geoBoardData.geoLoc;
  const locationName = geoBoardData.geoLocName;
  const allTotalDrawCount = totalDrawCount + addonTotalDrawCount;
  const distanceFromTopWin = wagerHelper.getDistanceFromWin(wager, result, false);
  const distanceFromWin = wagerHelper.getDistanceFromWin(wager, result, true);
  const currentWin = wagerHelper.getWin(wager, result);
  const completedDrawTime = wagerHelper.getCompletedDrawTime(wager, result);
  const isWin = Boolean(currentWin);
  const isDiv1 = isWin && currentWin.winDiv === 0;
  const drawsCount = completedDraws.filter(draw => new Date(draw.time) < new Date(result.regCloseTime)).length + 1;
  const isProlongable = wagerHelper.getIsProlongable(wager);
  const Bold = _ref2 => {
    let {
      children
    } = _ref2;
    return React.createElement("span", {
      className: "f-bold"
    }, children);
  };
  const isCustomerSupport = svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE);
  const totalWinAmount = wager.wins.reduce((acc, win) => acc + parseInt(win.amount, 10), 0);
  return React.createElement("div", {
    className: "wager-summary",
    "data-wager-id": wager.wagerId
  }, React.createElement("div", {
    className: "wager-summary-content"
  }, React.createElement("div", {
    className: "wager-summary-header"
  }, locationName), React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Betalt:"), " ", React.createElement("span", null, FormatTime("d/M', kl. 'HH:mm", regWagerTime)))), React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Insats:"), " ", React.createElement("span", null, formatCurrency(betAmount), " kr"))), (totalDrawCount > DRAWS.DRAWS_PER_WEEK || isSubscription) && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Insats per vecka:"), " ", React.createElement("span", null, isSubscription ? formatCurrency(parseInt(betAmount, 10)) : formatCurrency(parseInt(betAmount, 10) / DRAWS.NUMBER_OF_WEEKS), " kr"))), latitude && longitude && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Koordinater:"), " ", latitude, '\u00b0', "N - ", longitude, '\u00b0', "E")), !isDiv1 && distanceFromTopWin && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Avst\xE5nd till toppvinst:"), " ", distanceFromTopWin)), !isWin && distanceFromWin && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Avst\xE5nd till n\xE4rmaste vinst:"), " ", distanceFromWin)), charity && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Bidrar till:"), " ", charity.name)), !isSubscription && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell border-right"
  }, React.createElement(Bold, null, "Dragning:"), " ", React.createElement("span", null, drawsCount, " av ", allTotalDrawCount))), React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Avgjordes:"), " ", React.createElement("span", null, svs.utils.date.ShortDateAndTime(completedDrawTime, false, true)))), React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell bg-grey-200"
  }, React.createElement(Bold, null, "Spelat via:"), " ", React.createElement("span", {
    className: "f-capitalize"
  }, isSubscription ? 'Prenumeration' : channel))), wager.wins && wager.wins.length > 0 && React.createElement("div", {
    className: "wager-summary-row"
  }, !(currentWin && wager.wins.length === 1) && React.createElement("div", {
    className: "wager-summary-cell border-right"
  }, React.createElement(Bold, null, "Total vinst:"), " ", formatCurrency(totalWinAmount), " kr"), React.createElement("div", {
    className: "wager-summary-cell ".concat(currentWin && wager.wins.length === 1 && 'u-flex-justify-content-center')
  }, React.createElement(Bold, null, "Vinst:"), " ", formatCurrency((_currentWin$amount = currentWin === null || currentWin === void 0 ? void 0 : currentWin.amount) !== null && _currentWin$amount !== void 0 ? _currentWin$amount : 0), " kr")), currentWin && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell border-right"
  }, React.createElement(Bold, null, "Utbetalning:"), currentWin.payoutTarget), React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Utbetalningsdatum:"), " ", FormatTime('d/M', currentWin.payoutTime))), isCustomerSupport && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Wager ID:"), " ", wagerId))), isProlongable && React.createElement(ProlongButton, {
    wager: wager
  }));
};
setGlobal('svs.lyckoplatsen.components.shared_mybets_wager.react.components', {
  FinishedWagerSummary
});

 })(window);